/**
 * Номер картки для виводу реферальних (owner 2026-10-19, «як у Findly»).
 *
 * Та сама перевірка, що на сервері (`services/referral_payouts.card_clean`):
 * 13–19 цифр і контрольна сума Луна. Клієнт і сервер рахують однаково, інакше
 * кнопка горить, а сервер відповідає помилкою (правило проєкту).
 *
 * Номер ніде не зберігаємо: ні в localStorage, ні в URL — він живе лише в
 * стані попапа, поки той відкритий.
 */

/** Лише цифри, не більше 19. */
export function cardDigits(raw: string): string {
  return raw.replace(/\D/g, "").slice(0, 19);
}

/** `4111111111111111` → `4111 1111 1111 1111` (маска #### #### #### ####). */
export function formatCard(digits: string): string {
  return digits.replace(/(\d{4})(?=\d)/g, "$1 ");
}

function luhnOk(digits: string): boolean {
  let total = 0;
  for (let i = 0; i < digits.length; i++) {
    let n = Number(digits[digits.length - 1 - i]);
    if (i % 2) {
      n = n * 2;
      if (n > 9) n -= 9;
    }
    total += n;
  }
  return total % 10 === 0;
}

/** Номер правильний: 13–19 цифр і сходиться контрольна сума. */
export function isValidCard(digits: string): boolean {
  return digits.length >= 13 && digits.length <= 19 && luhnOk(digits);
}

/** `•••• 1111` — єдиний вигляд картки поза полем вводу. */
export function cardMask(digits: string): string {
  return `•••• ${digits.slice(-4)}`;
}
